import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionContractInfo, TypeActionContractInfo, } from "../actionContractInfo";
export var epicContractDismiss = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.RequestDismiss), switchMap(function (action) {
        var state = state$.value;
        return deps.netSend({
            id: CommandCode.DismissContract,
            props: {
                contractId: action.contractId,
                farmId: state.playerBase.base.baseId,
                playerId: state.playerInfo.playerId,
            },
        });
    }), retry(), map(function (res) { return actionContractInfo(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractDismiss.ts
// module id = 1988
// module chunks = 3